import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiTaRe300 } from '~/endpoints/ApiTaRe300'

// State types
type StateRanking = {
  results: {
    ranking: string
    score: string
    nickName: string
    schoolName: string
  }[]
}
const getEmptyStateRanking = (): StateRanking => ({
  results: [
    {
      ranking: '',
      score: '',
      nickName: '',
      schoolName: '',
    },
  ],
})

// State action parameter

interface ActionParamsRefleshRanking {
  fiscalYear: number
  testMonth: number
  testCountPerMonth?: number
  subjectCode: string
  grade: number
  courseId: string
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/diagnoseSchoolRanking',
})
export default class DiagnoseSchoolRanking extends VuexModule {
  // States

  // Sample
  private ranking_ = getEmptyStateRanking()

  // Getters

  // sample
  get ranking(): StateRanking {
    return this.ranking_
  }

  // Mutations

  @Mutation
  updateRanking(value: StateRanking) {
    this.ranking_ = value
  }

  // Actions

  @Action
  clear() {
    this.context.commit('updateRanking', getEmptyStateRanking())
  }

  @Action
  async refreshRanking(param: ActionParamsRefleshRanking) {
    logger.trace('in: refreshRanking')
    const api = new ApiTaRe300.Api()

    // API: Sample
    const request: ApiTaRe300.Get.Request = {
      query: {
        subjectCode: param.subjectCode,
        grade: param.grade,
        fiscalYear: param.fiscalYear,
        testMonth: param.testMonth,
        courseId: param.courseId,
      },
    }
    if (param.testCountPerMonth) {
      request.query.testCountPerMonth = param.testCountPerMonth
    }
    // success
    const result = await api.get<StateRanking | null>(
      request,
      (data, _) => {
        return {
          results: data.results,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateRanking', result)
  }
}
